'use client';
// import isbot from 'isbot';
// import { useMemo } from 'react';

const Map = () => {
  // const isBot = useMemo(() => typeof navigator !== 'undefined' && isbot(navigator.userAgent), []);
  // if (isBot) return null;
  return (
    <div className="mx-auto mt-6 max-w-4xl overflow-hidden rounded-xl ring-2 ring-orange-300">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2698.100841637313!2d21.396088676847345!3d47.448973698848455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4747197c7ec05a3b%3A0x84b8b15ba3c250b4!2zSGFqZMO6c3pvYm9zemzDsywgSsOzenNlZiBBdHRpbGEgdS4gNi1iLCA0MjAw!5e0!3m2!1shu!2shu!4v1687870002662!5m2!1shu!2shu"
        width="100%"
        height="450"
        loading="lazy"
        title="address"
        scrolling="no"
        unselectable="on"
        allowFullScreen={false}
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};
export default Map;
